export var drawerTheme = {
  baseStyle: {
    content: {
      display: 'flex',
      flexDirection: 'column',
      zIndex: 'modal',
      backgroundColor: 'neutral.white',
      height: '100%',
      width: '100%'
    },
    header: {
      display: 'flex',
      flexDirection: 'row-reverse',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 'l',
      padding: {
        xs: 's',
        s: 'xl'
      }
    },
    body: {
      paddingX: {
        xs: 's',
        s: 'xl'
      },
      paddingY: {
        xs: 'm',
        s: 'xl'
      }
    },
    footer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      borderTop: 'basic.light',
      height: '80px',
      paddingX: 'm',
      paddingY: 'none'
    }
  }
};
//# sourceMappingURL=Drawer.theme.js.map